import { computed, observable, runInAction } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';
import { FetchStatus } from '../util/FetchStatus';

export interface SecureNetStats {
  category: StatCategory;
  count: number;
}

export enum StatCategory {
  BOTNET = 'botnet',
  MALICIOUS = 'malicious',
  SPAM = 'spam',
  VIRUS = 'virus'
}

class SecureNetStore {
  @observable accessor stats: SecureNetStats[];
  @observable accessor status: FetchStatus = FetchStatus.UNINITIALIZED;

  public getSecureNetStats = async () => {
    if ([FetchStatus.FETCHING, FetchStatus.FETCHED].includes(this.status)) {
      return Promise.resolve();
    }
    runInAction(() => {
      this.status = FetchStatus.FETCHING;
    });
    try {
      const result = (await API.get('/securenet/stats', { timeout: 60000 })).data;
      runInAction(() => {
        this.stats = result;
        this.status = FetchStatus.FETCHED;
      });
    } catch (e) {
      runInAction(() => {
        this.status = FetchStatus.ERROR;
      });
      ErrorUtil.pushErrorToTeliaRumAndLog(e as Error);
    }
  };

  public getCategoryStats = (cat: StatCategory) => {
    return this.stats.find((category) => category.category === cat)?.count;
  };

  public getSumOfCategories = () => {
    return this.stats.reduce((acc, category) => acc + category.count, 0);
  };

  public getDate() {
    return new Date().toLocaleDateString('est');
  }

  @computed
  public get isLoaded() {
    return ![FetchStatus.FETCHING, FetchStatus.UNINITIALIZED].includes(this.status);
  }
}

export default SecureNetStore;
